import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field } from 'redux-form'
import { Card, CardContent, Grid, Paper } from '@material-ui/core'
import {
  renderCheckbox,
  renderMultiLineTextField
} from '../../form-global-components/components-form-components-for-react-final-form'
class FormFieldsTabAllSupervision extends Component {
  render () {
    return (
      <div>
        <Paper width='100%'>
{/* 
                                                                        <CardHeader
                                                                          title='Assigned CJ Supervision'
                                                                        />
                                                                        <Divider />
*/}
          <Card width='100%'>
            <CardContent width='100%'>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={renderCheckbox}
                    locked={this.props.locked}
                    id='othersupervisingofficer'
                    name='othersupervisingofficer'
                    objName='othersupervisingofficer'
                    label='Other Supervising Officer'
                    footerMessage=''
                  />
                </Grid>

                {this.props.programSelected === '1' ||
                this.props.programSelected === '2' ||
                this.props.programSelected === '4' ? (
                  <>
                    {/* BOP === 1 */}
                    {/* opcpsychiatric === 4 */}
                    {/* usporrc === 2 */}

                    <Grid item xs={12} sm={6}>
                      <Field
                        component={renderCheckbox}
                        locked={this.props.locked}
                        id='usprobationofficer'
                        name='usprobationofficer'
                        objName='usprobationofficer'
                        label='U.S. Probation Officer'
                        footerMessage=''
                      />
                    </Grid>
                  </>
                ) : (
                  ''
                )}

                {this.props.programSelected === '3' ||
                this.props.programSelected === '4' ? (
                  <>
                    {/* usptsresidential === 3 */}
                    {/* opcpsychiatric === 4 */}
                    <Grid item xs={12} sm={6}>
                      <Field
                        component={renderCheckbox}
                        locked={this.props.locked}
                        id='uspretrialofficer'
                        name='uspretrialofficer'
                        objName='uspretrialofficer'
                        label='U.S. Pretrial Officer'
                        footerMessage=''
                      />
                    </Grid>
                  </>
                ) : (
                  ''
                )}

                {this.props.programSelected === '5' ||
                this.props.programSelected === '6' ||
                this.props.programSelected === '7' ||
                this.props.programSelected === '8' ||
                this.props.programSelected === '9' ? (
                  <>
                    {/* bhts === 5 */}
                    {/* esperanza === 6 */}
                    {/* casamia === 7 */}
                    {/* opccounseling === 8 */}
                    {/* veterans === 9 */}

                    <Grid item xs={12} sm={6}>
                      <Field
                        component={renderCheckbox}
                        locked={this.props.locked}
                        id='specialtycourtcasemanager'
                        name='specialtycourtcasemanager'
                        objName='specialtycourtcasemanager'
                        label='Specialty Court Case Manager'
                        footerMessage=''
                      />
                    </Grid>
                  </>
                ) : (
                  ''
                )}

                {this.props.programSelected === '5' ||
                this.props.programSelected === '6' ||
                this.props.programSelected === '7' ? (
                  <>
                    {/* bhts === 5 */}
                    {/* esperanza === 6 */}
                    {/* casamia === 7 */}

                    <Grid item xs={12} sm={6}>
                      <Field
                        component={renderCheckbox}
                        locked={this.props.locked}
                        id='usprobationofficer'
                        name='usprobationofficer'
                        objName='usprobationofficer'
                        label='Bexas County Probation Officer'
                        footerMessage=''
                      />
                    </Grid>
                  </>
                ) : (
                  ''
                )}

                {this.props.programSelected === '5' ? (
                  <>
                    {/* bhts === 5 */}

                    <Grid item xs={12} sm={6}>
                      <Field
                        component={renderCheckbox}
                        locked={this.props.locked}
                        id='bexarcountypretrialofficer'
                        name='bexarcountypretrialofficer'
                        objName='bexarcountypretrialofficer'
                        label='Bexar County Pretrial Officer'
                        footerMessage=''
                      />
                    </Grid>
                  </>
                ) : (
                  ''
                )}

                {this.props.programSelected === '7' ? (
                  <>
                    {/* casamia === 7 */}

                    <Grid item xs={12} sm={6}>
                      <Field
                        component={renderCheckbox}
                        locked={this.props.locked}
                        id='cpscaseworker'
                        name='cpscaseworker'
                        objName='cpscaseworker'
                        label='CPS Case Worker'
                        footerMessage=''
                      />
                    </Grid>
                  </>
                ) : (
                  ''
                )}

                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Field
                      locked={this.props.locked}
                      component={renderMultiLineTextField}
                      id='supervisioncomments'
                      name='supervisioncomments'
                      label='Supervision Comments'
                      rows='6'
                      emptyText='Your comments should be clear and concise.'
                      footerMessage='Your comments should be clear and concise.'
                    />
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Paper>
      </div>
    )
  }
}
FormFieldsTabAllSupervision.propTypes = {
  locked: PropTypes.bool,
  programSelected: PropTypes.string
  // programSelected: PropTypes.number,
}
export default FormFieldsTabAllSupervision